import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { IIndirectTaxFilingV2TransactionSummaryResponse } from './types';

export function useIndirectTaxFilingV2TransactionSummary(
  filingId: string | null | undefined,
  corporationId: number | null | undefined,
  options?: { enabled?: boolean }
) {
  const enabled = options?.enabled ?? true;

  const key =
    enabled && filingId && corporationId
      ? `new-sales-tax/filings-v2/${filingId}/transaction-summary?corporationId=${corporationId}`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2TransactionSummaryResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    summaries: data?.summaries ?? [],
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
}
